var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "wizard-tab",
        staticStyle: { overflow: "auto", position: "relative", flex: "1" },
      },
      [_c("div", { attrs: { id: "chatchamp-wizard" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }